var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Tabela de ocorrências PROCEDA")]),_c('div',[_c('b-table',{attrs:{"hover":"","items":_vm.items,"fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }